import { Card, CardContent } from "@/components/ui/card";
import { SrIcon } from "@/components/ui/SrIcon";

/** Lastetilstand for fanene på ansattkortet. */
export function TabLoading() {
  return (
    <Card>
      <CardContent className="flex h-32 items-center justify-center p-6">
        <SrIcon name="loader2" className="h-4 w-4 animate-spin text-muted-foreground" />
      </CardContent>
    </Card>
  );
}
